import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  private subject = new Subject<unknown>();

  confirm(): void {
    this.setConfirmation();
  }

  private setConfirmation(): void {
    this.subject.next({});
  }

  getMessage(): Observable<unknown> {
    return this.subject.asObservable();
  }
}
